import { render, staticRenderFns } from "./Autocounter.vue?vue&type=template&id=5beb9553&"
import script from "./Autocounter.vue?vue&type=script&lang=js&"
export * from "./Autocounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports